// extracted by mini-css-extract-plugin
export default {"statsCard":"DashboardStats_statsCard__LTwjn"};